import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetVehicleQuery} from '@dms/api/vehicle';
import {useGetVehicleTitle} from '@dms/shared';

export function useTaskRelationVehicle(vehicleId: string) {
  const {
    data: vehicle,
    isLoading: isVehicleLoading,
    isError: isVehicleError,
  } = useGetVehicleQuery({vehicleId}, {skip: isNilOrEmpty(vehicleId)});

  const [vehicleTitle, {isLoading: isVehicleTitleLoading, isError: isVehicleTitleError}] =
    useGetVehicleTitle(vehicle);

  return {
    vehicle,
    vehicleTitle,
    isLoading: isVehicleLoading || isVehicleTitleLoading,
    isError: isVehicleError || isVehicleTitleError,
  };
}
